import type { Page } from '../../types';
import { getColumns, getKeys, getRows } from '../../../components/form/CoreTtfConsolidatedInput';

const timeToFill: Page[] = [
  {
    pageType: 'information',
    title: 'Before you start',
    name: 'before-you-start',
    continueConfirmation: 'I have read and understand the guidance',
    description: `
	  <strong>Overview</strong><br>
	  Time To Fill is the total time required to fill a role. It is used to inform workforce planning and give an understanding of the duration of recruitment processes not covered by Time To Hire. It covers the days between vacancy go live date to the successful candidate’s start date. Because the total recruitment process is rarely captured solely by one system in the Civil Service, Time To Fill will likely need to be calculated by combining segmented measurements, including Time To Hire. <strong>Given the complexity of calculating Time To Fill, reasonable use of estimations and assumptions is acceptable.</strong> Departments should provide context as to the inclusions and confidence in their Time To Fill reporting, and a timeframe for improving upon that where necessary. Time To Fill measurements should be classified and monitored according to the grade structure of the department.<br><br>

	  <strong>Methodology</strong><br>
	  Time to Fill is the total number of days elapsed from the date the vacancy advert goes live to the successful candidate's start date.<br><br>

	  To ensure data consistency, departments are required to report on the recruitment cycle duration only. This covers the period from the advert go-live date to the formal offer date (or the appropriate comparable terminal status within Applicant Tracking Systems).<br><br>

	  Once data is submitted, a central 'Post-Offer Buffer' will be applied to TTF figures by the central GPG and CO Digital team. This buffer represents the estimated time for pre-employment checks, vetting, and notice periods. This is calculated using a universal median average derived from available data. This buffer will vary depending on recruitment approach (External/Non-External), Grade group (Delegated/SCS), and by vetting level (BPSS/CTC/SC/DV).<br><br>

	  All durations must be submitted as a median average.<br><br>

	  <strong>Applications to include</strong><br>
	  For Time to Fill, assign applications to a reporting quarter based upon their formal offer date<br><br>

	  Campaigns based on an Expression of Interest, reserve list appointment, or where no successful candidate is identified, should be omitted.
	`,
  },
  {
    pageType: 'question',
    title: 'Time to Fill',
    name: 'time-to-fill',
    questions: [
      {
        questionType: 'CoreTtfConsolidatedInput',
        title: 'Median Time to Fill measurements in Calendar Days',
        name: 'ttf-median',
        rules: {
          required: true,
          decimal: 'decimal(2)',
        },
      },
      {
        questionType: 'textarea',
        title: 'Reporting confidence',
        name: 'ttf-confidence',
        hint: 'Please indicate the confidence level and completeness of these measurements, estimations and assumptions used, and plans to improve or change this reporting in future.',
        rules: {
          required: false,
        },
      },
      {
        questionType: 'textarea',
        title: 'Progress towards benchmark',
        name: 'ttf-benchmark',
        hint: 'What action has been taken in the last quarter to move toward the benchmark.',
        rules: {
          required: true,
        },
      },
    ],
  },
];

export default timeToFill;
